import React, { useCallback, useMemo, useRef, useState } from 'react'

import { BoxPaywallContextValue, BoxPaywallStatus } from '../../types'
import { BoxLockContext } from '../context'

type PaywallProviderProps = {
  children: React.ReactNode
}

export function PaywallProvider(props: PaywallProviderProps) {
  const { children } = props

  const [status, setStatus] = useState<BoxPaywallStatus>('open')
  const prevStatusRef = useRef<BoxPaywallStatus | null>(null)

  const setStatusWrapper = useCallback((newStatus: BoxPaywallStatus) => {
    setStatus((prevStatus) => {
      prevStatusRef.current = prevStatus
      return newStatus
    })
  }, [])

  const providerValue: BoxPaywallContextValue = useMemo(
    () => ({
      componentType: 'paywall',
      initialized: true,
      status,
      prevStatus: prevStatusRef.current,
      setStatus: setStatusWrapper,
      open: true,
      interactive: ['ready', 'error'].includes(status),
      prefetch: true,
      enableSuccessScreen: false,
    }),
    [setStatusWrapper, status]
  )

  return <BoxLockContext.Provider value={providerValue}>{children}</BoxLockContext.Provider>
}
